import { Box, Link, Icon, IconButton, Divider, Card } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import LinkIcon from '@mui/icons-material/Link';
import { atom, useAtom, useAtomValue, useSetAtom } from 'jotai';

// common
import { dic } from "@common/text_defs";
// component
import { handleOpenDlgContactUs, } from "@pages/contact/ContactUsDialog";

const WorksSection = () => {
  const openContactUsDlg = useSetAtom(handleOpenDlgContactUs);

  const paneList = [
    {
      imageUrl: "./assets/images/prod-OEMS.jpg",
      name: dic.works.prod_OEMS.title,
      description: dic.works.prod_OEMS.desc,
      link: "/prod_data_hub_x",
    },
    {
      imageUrl: "./assets/images/data-extract.png",
      name: dic.works.grid_sync.title,
      description: dic.works.grid_sync.desc,
      link: "/prod_grid_sync",
    },
    {
      imageUrl: "./assets/images/strgy-master-pro.jpg",
      name: dic.works.prod_futsMS.title,
      description: dic.works.prod_futsMS.desc,
      link: "/prod_flex_flow",
    },
    {
      imageUrl: "./assets/images/prod_DR.png",
      name: dic.works.flex_trading_2.title,
      description: dic.works.flex_trading_2.desc,
      //link: "/prod_flex_trading2",
      link: "#",
    },
  ];
  const handleAction = async (act: string, vd: unknown) => {
  }
  const handleClickLink = async (link: string) => {
    if (link === "#") {
      openContactUsDlg(handleAction)
    } else {
      window.location.href = link
    }
  }

  return (
    <Box component="section" className="section bg-light-gray" id="works" sx={{ pb: 0 }}>
      <Box component="div" className="container">
        <div className="section__header">
          <h2>{dic.works.main_title}</h2>
          <p>
            {dic.works.sub_title}
          </p>
        </div>
        <Grid container spacing={3}>
          {paneList.map((pane, index) => (
            <Grid md={3} sm={6} xs={12} key={index}>
              <Card className="relative card" sx={{ height: "100% !important", display: "flex", flexDirection: "column" }}>
                {pane.link ? <Link href="#" onClick={() => handleClickLink(pane.link)}><img
                  className="w-full"
                  src={pane.imageUrl}
                  alt="portfolio"
                /></Link> : <img
                  className="w-full"
                  src={pane.imageUrl}
                  alt="portfolio"
                />}
                <Box sx={{ px: 4, pt: 4 }}>
                  <h5 className="m-0 text-16 font-bold">{pane.name}</h5>
                  <p className="mb-4">{pane.description}</p>
                </Box>
                <Box sx={{ flexGrow: 1 }}></Box>
                {pane.link && pane.link !== "#" && <><Divider />
                  <Box sx={{ px: 4, py: 2, }}>
                    <Link href={pane.link}>
                      <LinkIcon />
                    </Link>
                  </Box> </>}
              </Card>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Box >
  );
};

export { WorksSection };
